module.exports = __webpack_public_path__ + "img/zuijia_32.9fbad661.png";